// Module
var code = `<div ng-transclude></div>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/common/query-param-guard/query-param-guard.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;